<template>
  <div class="content">
    <QuizHeader/>
    <div :style="{background: bgTheme}" style="height: 200px"></div>
    <div class="container-fluid" style="margin: -155px auto 0 auto; width:97%">
      <div class="congrats-section common-block">
        <div class="circle-timer-section" style="z-index: 999" >
          <div class="timer">
            <span class="text-large">Hrs</span>
            <span class="text-large">:Mns</span>
            <span class="text-large">:Sec</span>
            <div class="question_timer is-countdown">
              <span class="countdown-row countdown-amount">
               {{'00'}} : {{Math.floor(time_left/60)<10?'0'+Math.floor(time_left/60):Math.floor(time_left/60)}} :  {{(time_left)%60 }}
              </span>
            </div>
          </div>
        </div>
        <img :src="data_to_show[0].image_url"
             style="margin-top: 25px"
             alt="congrats" class="img-fluid w30"
             v-if="data_to_show[0] && data_to_show[0].image_url">
        <img src="@/assets/congrats.svg" alt="congrats" class="img-fluid" v-else>

        <span v-if="data_to_show[0] && data_to_show[0].message" v-html="data_to_show[0].message"></span>
        <span v-else>Congrats on the completing the Quiz!</span>

        <p>Quiz Score {{answers_score}} <span>Time Bonus {{time_score}}</span></p>

        <span>Total Score is {{total_score}}</span>

        <div
            class="btn btn-pink see-leadboard text-uppercase"
            role="button"
            v-on:click="handleButtonClick()"
        >
          {{data_to_show[0] && data_to_show[0].button_text ? data_to_show[0].button_text : 'See Leaderboard'}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Tasks from '../components/Tasks'
import { globals } from "@/mixins/globals"
import QuizHeader from '@/components/quiz-header'
export default {
  mixins: [globals],
  name: 'congrats',
  components: {
    QuizHeader
  },
  data: () => ({
    total_score: 0,
    total_questions: 0,
    correct_answers: 0,
    answers_score: 0,
    time_score: 0,
    final_screen_data: [],
    data_to_show: '',
    displayDays: 0,
    displayHours: 0,
    displayMinutes: 0,
    displaySeconds: 0,
    distance: 3600000,
    time_left: 0,
  }),
  computed: {
    _seconds: () => 1000,
    _minutes() {
      return this._seconds * 60
    },
    _hours() {
      return this._minutes * 60
    },
    _days() {
      return this._hours * 24
    },
  },
  methods: {
    handleButtonClick() {
      /*if (this.data_to_show.deeplink) {
        window.open(this.data_to_show.deeplink, "_blank")
        this.back();
      } else {*/
        this.$router.replace('/quiz-history');
      /*}*/
    },
    showRemaining() {
      const timer = setInterval(() => {
        if (this.distance < 0) {
          if (this.quizNo == (this.quizData.length - 1)) {
            clearInterval(timer);
          }
          // this.submitAnswers();
          this.handleNextQuestion();
          return
        }
        const seconds = parseInt(Math.floor(this.distance % this._minutes) / this._seconds);
        const minutes = parseInt(Math.floor(this.distance % this._hours) / this._minutes);
        const days = parseInt(Math.floor(this.distance / this._days));
        const hours = parseInt(Math.floor(this.distance % this._days) / this._hours);


        this.displayMinutes = minutes < 10 ? "0" + minutes : minutes + "m";
        this.displaySeconds = seconds < 10 ? "0" + seconds : seconds + "s";
        this.displayHours = hours < 10 ? "0" + hours : hours + "h";
        this.displayDays = days < 10 ? "0" + days : days;
        this.distance = this.distance - 1000
      }, 1000)
    }
  },
  created() {
    // this.$emit('handleHideFooter');
    var self = this
    this.showRemaining();
    this.total_score = this.$route.params.total_score;
    this.total_questions = this.$route.params.total_questions;
    this.correct_answers = this.$route.params.correct_answers;
    this.answers_score = this.$route.params.answers_score;
    this.time_score = this.$route.params.time_score;
    this.final_screen_data = this.$route.params.final_screen_data;
    this.time_left = this.$store.state.quiz_time_bonus;
    this.$store.state.quizDetailsTitle = "Congrats"
    this.data_to_show = this.$store.state.final_screen_data;
    this.final_screen_data.forEach(function (data) {
      if (self.correct_answers == 0) {
        if (data.configuration_type == "zero") {
          self.data_to_show = data;
          return;
        }
      } else if (self.correct_answers < self.total_questions) {
        if (data.configuration_type == "less_than") {
          self.data_to_show = data;
          return;
        }
      } else {
        if (data.configuration_type == "greater_than") {
          self.data_to_show = data;
          return;
        }
      }
    });
    if (self.data_to_show) {
      self.data_to_show.button_text = null;
    }

    // console.log(this.data_to_show)
  },
  mounted() {
    this.$store.state.showQuizHistoryMenu = false;
  }
}
</script>

<style scoped>
  @import '../assets/quiz-styles/quiz-styles.css';
  /*@import '../assets/quiz-styles/bootstrap.css';*/
  @import '../assets/fonts/quiz-fonts/fonts.css';
</style>



// WEBPACK FOOTER //
// src/screens/congrats.vue